import * as debugModule from 'debug';

// Centralized enum for all log events
export enum TaarWebRTCEvents {
  // Registration events
  INITIAL_REGISTRATION_SUCCESSFUL = 'INITIAL_REGISTRATION_SUCCESSFUL',
  RE_REGISTRATION_SUCCESSFUL = 'RE_REGISTRATION_SUCCESSFUL',
  RE_REGISTRATION_COMPLETED = 'RE_REGISTRATION_COMPLETED',
  REGISTRATION_STATE_TRUE = 'REGISTRATION_STATE_TRUE',
  REGISTRATION_STATE_FALSE = 'REGISTRATION_STATE_FALSE',
  REGISTRATION_FAILED = 'REGISTRATION_FAILED',
  RE_REGISTRATION_FAILED = 'RE_REGISTRATION_FAILED',
  UNREGISTERED = 'UNREGISTERED',
  
  // Connection events
  CONNECTED_TO_WEBRTC = 'CONNECTED_TO_WEBRTC',
  WEBSOCKET_CONNECTION_LOST = 'WEBSOCKET_CONNECTION_LOST',
  WEBSOCKET_RECONNECTION_ATTEMPT = 'WEBSOCKET_RECONNECTION_ATTEMPT',
  WEBSOCKET_RECONNECTION_SUCCESSFUL = 'WEBSOCKET_RECONNECTION_SUCCESSFUL',
  WEBSOCKET_INITIAL_CONNECTION = 'WEBSOCKET_INITIAL_CONNECTION',
  WEBSOCKET_CONNECTING = 'WEBSOCKET_CONNECTING',
  WEBSOCKET_CONNECTED = 'WEBSOCKET_CONNECTED',
  WEBSOCKET_DISCONNECTED = 'WEBSOCKET_DISCONNECTED',
  NEW_SOCKET_DURING_RECONNECTION = 'NEW_SOCKET_DURING_RECONNECTION',
  MULTIPLE_SOCKETS_DETECTED = 'MULTIPLE_SOCKETS_DETECTED',
  SINGLE_SOCKET = 'SINGLE_SOCKET',
  
  // Call events
  CALL_PROGRESS = 'CALL_PROGRESS',
  CALL_ACCEPTED = 'CALL_ACCEPTED',
  CALL_ENDED = 'CALL_ENDED',
  CALL_FAILED = 'CALL_FAILED',
  INCOMING_CALL_RECEIVED = 'INCOMING_CALL_RECEIVED',
  INCOMING_CALL_PROCESSING = 'INCOMING_CALL_PROCESSING',
  INCOMING_CALL_PEER_CONNECTION = 'INCOMING_CALL_PEER_CONNECTION',
  INCOMING_CALL_PROGRESS = 'INCOMING_CALL_PROGRESS',
  INCOMING_CALL_ACCEPTED = 'INCOMING_CALL_ACCEPTED',
  INCOMING_CALL_ENDED = 'INCOMING_CALL_ENDED',
  INCOMING_CALL_FAILED = 'INCOMING_CALL_FAILED',
  INCOMING_CALL_NOTIFICATION = 'INCOMING_CALL_NOTIFICATION',
  OUTGOING_CALL_PEER_CONNECTION = 'OUTGOING_CALL_PEER_CONNECTION',
  CALL_STATE_ACTIVE = 'CALL_STATE_ACTIVE',
  CALL_STATE_INACTIVE = 'CALL_STATE_INACTIVE',
  CALL_FAILURE_STATE_UPDATED = 'CALL_FAILURE_STATE_UPDATED',
  
  // Audio events
  AUDIO_STREAMS_SETUP = 'AUDIO_STREAMS_SETUP',
  AUDIO_STREAM_SETUP_COMPLETE = 'AUDIO_STREAM_SETUP_COMPLETE',
  AUDIO_ELEMENT_CONFIGURED = 'AUDIO_ELEMENT_CONFIGURED',
  AUDIO_ELEMENT_VOLUME_UPDATED = 'AUDIO_ELEMENT_VOLUME_UPDATED',
  AUDIO_ELEMENT_CLEANUP = 'AUDIO_ELEMENT_CLEANUP',
  CALL_MUTED = 'CALL_MUTED',
  CALL_UNMUTED = 'CALL_UNMUTED',
  VOLUME_STATE_UPDATED = 'VOLUME_STATE_UPDATED',
  
  // DTMF events
  SEND_DTMF_STARTED = 'SEND_DTMF_STARTED',
  SEND_DTMF_NO_ACTIVE_CALL = 'SEND_DTMF_NO_ACTIVE_CALL',
  SEND_DTMF_INVALID_TONES = 'SEND_DTMF_INVALID_TONES',
  SEND_DTMF_SUCCESSFUL = 'SEND_DTMF_SUCCESSFUL',
  SEND_DTMF_FAILED = 'SEND_DTMF_FAILED',
  
  // Session events
  SESSION_SETUP_EVENT_HANDLERS = 'SESSION_SETUP_EVENT_HANDLERS',
  SESSION_FAILED = 'SESSION_FAILED',
  SESSION_ENDED = 'SESSION_ENDED',
  SESSION_ACCEPTED = 'SESSION_ACCEPTED',
  SESSION_TIMER_INFO = 'SESSION_TIMER_INFO',
  
  // Peer connection events
  ICE_CONNECTION_STATE_CHANGE = 'ICE_CONNECTION_STATE_CHANGE',
  CONNECTION_STATE_CHANGE = 'CONNECTION_STATE_CHANGE',
  SIGNALING_STATE_CHANGE = 'SIGNALING_STATE_CHANGE',
  ICE_GATHERING_STATE_CHANGE = 'ICE_GATHERING_STATE_CHANGE',
  ICE_CANDIDATE = 'ICE_CANDIDATE',
  NEGOTIATION_NEEDED = 'NEGOTIATION_NEEDED',
  DATA_CHANNEL_CREATED = 'DATA_CHANNEL_CREATED',
  PEER_CONNECTION_MONITORING_CONFIGURED = 'PEER_CONNECTION_MONITORING_CONFIGURED',
  
  // Transaction events
  TRANSACTION_MESSAGE_DETECTED = 'TRANSACTION_MESSAGE_DETECTED',
  TRANSACTION_TIMERS_DETECTED = 'TRANSACTION_TIMERS_DETECTED',
  MESSAGE_TRANSPORT_DETECTED = 'MESSAGE_TRANSPORT_DETECTED',
  
  // UA events
  UA_CONNECTED_EVENT = 'UA_CONNECTED_EVENT',
  UA_REGISTERED_EVENT = 'UA_REGISTERED_EVENT',
  UA_UNREGISTERED_EVENT = 'UA_UNREGISTERED_EVENT',
  UA_REGISTRATION_FAILED_EVENT = 'UA_REGISTRATION_FAILED_EVENT',
  UA_NEW_RTC_SESSION_EVENT = 'UA_NEW_RTC_SESSION_EVENT',
  UA_NEW_OPTIONS_REQUEST = 'UA_NEW_OPTIONS_REQUEST',
  UA_NEW_MESSAGE_REQUEST = 'UA_NEW_MESSAGE_REQUEST',
  UA_LEVEL_NEGATIVE_FLOW_HANDLERS_CONFIGURED = 'UA_LEVEL_NEGATIVE_FLOW_HANDLERS_CONFIGURED',
  SESSION_LEVEL_NEGATIVE_FLOW_HANDLERS_CONFIGURED = 'SESSION_LEVEL_NEGATIVE_FLOW_HANDLERS_CONFIGURED',
  
  // WebSocket interface events
  WEBSOCKET_SEND_INTERCEPTED = 'WEBSOCKET_SEND_INTERCEPTED',
  WEBSOCKET_CONNECT_INTERCEPTED = 'WEBSOCKET_CONNECT_INTERCEPTED',
  WEBSOCKET_DISCONNECT_INTERCEPTED = 'WEBSOCKET_DISCONNECT_INTERCEPTED',
  WEBSOCKET_INTERFACE_MONITORING_CONFIGURED = 'WEBSOCKET_INTERFACE_MONITORING_CONFIGURED',
  
  // UA state monitoring events
  UA_STATE_CHANGE_DETECTED = 'UA_STATE_CHANGE_DETECTED',
  
  // Root cause events
  NETWORK_OFFLINE_DETECTED = 'NETWORK_OFFLINE_DETECTED',
  NETWORK_ONLINE_DETECTED = 'NETWORK_ONLINE_DETECTED',
  UA_CONNECTION_LOST = 'UA_CONNECTION_LOST',
  REGISTRATION_EXPIRED_DETECTED = 'REGISTRATION_EXPIRED_DETECTED',
  
  // Registration events (ALL variants)
  ALL_REGISTERED_EVENT = 'ALL_REGISTERED_EVENT',
  ALL_UNREGISTERED_EVENT = 'ALL_UNREGISTERED_EVENT',
  ALL_REGISTRATION_FAILED_EVENT = 'ALL_REGISTRATION_FAILED_EVENT',
  
  // WebSocket events (ALL variants)
  ALL_WEBSOCKET_CONNECTING_EVENT = 'ALL_WEBSOCKET_CONNECTING_EVENT',
  ALL_WEBSOCKET_CONNECTED_EVENT = 'ALL_WEBSOCKET_CONNECTED_EVENT',
  ALL_WEBSOCKET_DISCONNECTED_EVENT = 'ALL_WEBSOCKET_DISCONNECTED_EVENT',
  
  // Message events (ALL variants)
  ALL_NEW_MESSAGE_EVENT = 'ALL_NEW_MESSAGE_EVENT',
  
  // Process events
  REGISTRATION_PROCESS_STARTED = 'REGISTRATION_PROCESS_STARTED',
  CREDENTIALS_FETCHED = 'CREDENTIALS_FETCHED',
  WEBSOCKET_INTERFACE_CREATED = 'WEBSOCKET_INTERFACE_CREATED',
  UA_CREATION_STARTED = 'UA_CREATION_STARTED',
  UA_EVENT_HANDLERS_SETUP = 'UA_EVENT_HANDLERS_SETUP',
  UA_STARTED = 'UA_STARTED',
  UA_STARTED_STATE_CHECK = 'UA_STARTED_STATE_CHECK',
  UNREGISTER_PROCESS_STARTED = 'UNREGISTER_PROCESS_STARTED',
  UNREGISTER_UA_NOT_INITIALIZED = 'UNREGISTER_UA_NOT_INITIALIZED',
  UNREGISTER_PROCESS_COMPLETE = 'UNREGISTER_PROCESS_COMPLETE',
  MAKE_CALL_STARTED = 'MAKE_CALL_STARTED',
  MAKE_CALL_UA_NOT_INITIALIZED = 'MAKE_CALL_UA_NOT_INITIALIZED',
  MAKE_CALL_ALREADY_IN_PROGRESS = 'MAKE_CALL_ALREADY_IN_PROGRESS',
  MAKE_CALL_OPTIONS_CONFIGURED = 'MAKE_CALL_OPTIONS_CONFIGURED',
  MAKE_CALL_INITIATED = 'MAKE_CALL_INITIATED',
  MAKE_CALL_EVENT_HANDLERS_SETUP = 'MAKE_CALL_EVENT_HANDLERS_SETUP',
  MAKE_CALL_FAILED = 'MAKE_CALL_FAILED',
  END_CALL_STARTED = 'END_CALL_STARTED',
  END_CALL_NO_ACTIVE_CALL = 'END_CALL_NO_ACTIVE_CALL',
  END_CALL_AUDIO_CLEANUP = 'END_CALL_AUDIO_CLEANUP',
  END_CALL_SESSION_TERMINATION = 'END_CALL_SESSION_TERMINATION',
  END_CALL_SUCCESSFUL = 'END_CALL_SUCCESSFUL',
  MUTE_CALL_STARTED = 'MUTE_CALL_STARTED',
  MUTE_CALL_NO_ACTIVE_CALL = 'MUTE_CALL_NO_ACTIVE_CALL',
  MUTE_SESSION_COMPLETE = 'MUTE_SESSION_COMPLETE',
  MUTE_STATE_UPDATED = 'MUTE_STATE_UPDATED',
  UNMUTE_CALL_STARTED = 'UNMUTE_CALL_STARTED',
  UNMUTE_CALL_NO_ACTIVE_CALL = 'UNMUTE_CALL_NO_ACTIVE_CALL',
  UNMUTE_SESSION_COMPLETE = 'UNMUTE_SESSION_COMPLETE',
  UNMUTE_STATE_UPDATED = 'UNMUTE_STATE_UPDATED',
  SET_VOLUME_STARTED = 'SET_VOLUME_STARTED',
  SET_VOLUME_AUDIO_ELEMENT_UPDATED = 'SET_VOLUME_AUDIO_ELEMENT_UPDATED',
  SET_VOLUME_STATE_UPDATED = 'SET_VOLUME_STATE_UPDATED',
  ANSWER_CALL_STARTED = 'ANSWER_CALL_STARTED',
  ANSWER_CALL_NO_INCOMING_CALL = 'ANSWER_CALL_NO_INCOMING_CALL',
  ANSWER_CALL_OPTIONS = 'ANSWER_CALL_OPTIONS',
  ANSWER_CALL_SUCCESSFUL = 'ANSWER_CALL_SUCCESSFUL',
  ANSWER_CALL_STATE_UPDATED = 'ANSWER_CALL_STATE_UPDATED',
  ANSWER_CALL_FAILED = 'ANSWER_CALL_FAILED',
  REJECT_CALL_STARTED = 'REJECT_CALL_STARTED',
  REJECT_CALL_NO_INCOMING_CALL = 'REJECT_CALL_NO_INCOMING_CALL',
  REJECT_CALL_SUCCESSFUL = 'REJECT_CALL_SUCCESSFUL',
  REJECT_CALL_FAILED = 'REJECT_CALL_FAILED',
  
  // Error events
  REGISTRATION_FAILED_ERROR = 'REGISTRATION_FAILED_ERROR',
  MAKE_CALL_ERROR = 'MAKE_CALL_ERROR',
  ANSWER_CALL_ERROR = 'ANSWER_CALL_ERROR',
  HANDLE_CALL_ACCEPTANCE_ERROR = 'HANDLE_CALL_ACCEPTANCE_ERROR',
  FETCH_NONCE_STARTED = 'FETCH_NONCE_STARTED',
  FETCH_NONCE_SUCCESSFUL = 'FETCH_NONCE_SUCCESSFUL',
  FETCH_NONCE_FAILED = 'FETCH_NONCE_FAILED',
  
  // Socket tracking events
  SOCKET_EVENT_DETECTED = 'SOCKET_EVENT_DETECTED',
  SOCKET_CONNECTING = 'SOCKET_CONNECTING',
  SOCKET_CONNECTED = 'SOCKET_CONNECTED',
  SOCKET_DISCONNECTED = 'SOCKET_DISCONNECTED',
  SOCKET_EVENT = 'SOCKET_EVENT',
  
  // Ignored events
  IGNORING_NON_REMOTE_CALL = 'IGNORING_NON_REMOTE_CALL',
  
  // No session events
  NO_ACTIVE_CALL = 'NO_ACTIVE_CALL',
  NO_SESSION_CONNECTION = 'NO_SESSION_CONNECTION',
  NO_REMOTE_STREAMS = 'NO_REMOTE_STREAMS',
  NO_AUDIO_ELEMENT = 'NO_AUDIO_ELEMENT',
  UNKNOWN_CALL = 'UNKNOWN_CALL',
  SESSION_CLEARED = 'SESSION_CLEARED',
  SOCKET_TRACKING = 'SOCKET_TRACKING',
  CAUSE_TRACKING = 'CAUSE_TRACKING',
  SOCKET_MONITORING = 'SOCKET_MONITORING',
  NONCE_FETCH = 'NONCE_FETCH',
  UA_CONNECTION = 'UA_CONNECTION',
  UA_REGISTRATION = 'UA_REGISTRATION',
  UA_UNREGISTRATION = 'UA_UNREGISTRATION',
  UA_REGISTRATION_FAILED = 'UA_REGISTRATION_FAILED',
  OPTIONS_MESSAGE = 'OPTIONS_MESSAGE',
  MESSAGE = 'MESSAGE',
  OUTGOING_CALL = 'OUTGOING_CALL',
  REGISTRATION_PROCESS = 'REGISTRATION_PROCESS',
  UNREGISTER_PROCESS = 'UNREGISTER_PROCESS',
  UA_SETUP = 'UA_SETUP'
}

export interface LogContext {
  callId?: string;
  timestamp?: number;
  event?: TaarWebRTCEvents;
  userAgent?: string;
  [key: string]: any;
}

export interface LogEntry {
  timestamp: number;
  level: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR';
  category: string;
  message: string;
  data?: any;
  context?: LogContext;
}

export interface LoggingConfig {
  enableConsole?: boolean;
  enableBackend?: boolean;
  backendUrl?: string;
  logLevel?: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR';
  maxLogEntries?: number;
  enableBatchLogging?: boolean;
  batchSize?: number;
  batchTimeout?: number;
  logGatewayUrl?: string;
  agentCredentials?: string;
  userAgent?: string;
}

export interface BatchLogEntry {
  message: string;
  context: LogContext;
  timestamp: number;
  level: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR';
}

export class UnifiedLogger {
  private static instance: UnifiedLogger;
  private logs: LogEntry[] = [];
  private config: LoggingConfig;
  private originalConsole: {
    log: typeof console.log;
    warn: typeof console.warn;
    error: typeof console.error;
  };
  private logBuffer: BatchLogEntry[] = [];
  private batchTimer: NodeJS.Timeout | null = null;
  private debugMode: boolean = false;

  private constructor(config: LoggingConfig = {}) {
    this.config = {
      enableConsole: true,
      enableBackend: false,
      logLevel: 'DEBUG',
      maxLogEntries: 1000,
      enableBatchLogging: false,
      batchSize: 50,
      batchTimeout: 5000,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'Unknown',
      ...config
    };

    this.originalConsole = {
      log: console.log,
      warn: console.warn,
      error: console.error
    };

    this.setupJsSIPLogging();
    this.setupConsoleInterception();
    
    if (this.config.enableBatchLogging && this.config.logGatewayUrl && this.config.agentCredentials) {
      this.startBatchTimer();
    }
  }

  static getInstance(config?: LoggingConfig): UnifiedLogger {
    if (!UnifiedLogger.instance) {
      UnifiedLogger.instance = new UnifiedLogger(config);
    }
    return UnifiedLogger.instance;
  }

  private setupJsSIPLogging() {
    // Enable JsSIP debug logging
    debugModule.enable('JsSIP:*,JsSIP:*:*');
    console.log('Active debug namespaces:', debugModule.names);

    // Create a custom log function that captures JsSIP logs
    const customDebugLog = (...args: any[]) => {
      const message = args.map(String).join(' ');
      
      // Determine log level based on message content
      let level: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR' = 'DEBUG';
      if (message.toLowerCase().includes('error') || message.toLowerCase().includes('failed')) {
        level = 'ERROR';
      } else if (message.toLowerCase().includes('WARNING')) {
        level = 'WARN';
      } else if (message.toLowerCase().includes('INFO')) {
        level = 'INFO';
      }

      // Special handling for timer expiration messages
      if (message.includes('Timer') && (message.includes('expired') || message.includes('Timer J') || message.includes('Timer F') || message.includes('Timer H'))) {
        level = 'WARN';
        
        // Extract timer information
        const timerMatch = message.match(/Timer\s+([A-Z])\s+expired/);
        const transactionMatch = message.match(/transaction\s+([a-f0-9]+)/);
        
        const timerInfo = {
          timerType: timerMatch ? timerMatch[1] : 'Unknown',
          transactionId: transactionMatch ? transactionMatch[1] : 'Unknown',
          fullMessage: message
        };

        // Create enhanced log entry for timer events
        const logEntry: LogEntry = {
          timestamp: +Date.now(),
          level: 'WARN',
          category: 'JsSIP-Timer',
          message: `Timer ${timerInfo.timerType} expired for transaction ${timerInfo.transactionId}`,
          data: timerInfo
        };

        this.addLogEntry(logEntry);
        this.originalConsole.warn(`[TaarWebRTC] Timer expiration detected:`, timerInfo);
        return;
      }

      // Create log entry
      const logEntry: LogEntry = {
        timestamp: +Date.now(),
        level,
        category: 'JsSIP',
        message,
        data: args.length > 1 ? args.slice(1) : undefined
      };

      // Add to logs array
      this.addLogEntry(logEntry);

      // Call original console log
      this.originalConsole.log(...args);
    };

    // Override the global debug log function to capture JsSIP logs
    const globalDebug = (globalThis as any).debug;
    if (globalDebug) {
      const originalDebugLog = globalDebug.log;
      globalDebug.log = customDebugLog;
    } else {
      // If no global debug, create one
      (globalThis as any).debug = {
        log: customDebugLog
      };
    }
  }

  private setupConsoleInterception() {
    // Override console methods to capture additional logs
    console.log = (...args: any[]) => {
      const message = args.map(String).join(' ');
      if (message.includes('JsSIP') || message.includes('TaarWebRTC')) {
        const logEntry: LogEntry = {
          timestamp: +Date.now(),
          level: 'INFO',
          category: 'TaarWebRTC',
          message,
          data: args.length > 1 ? args.slice(1) : undefined
        };
        this.addLogEntry(logEntry);
      }
      this.originalConsole.log(...args);
    };

    console.warn = (...args: any[]) => {
      const message = args.map(String).join(' ');
      const logEntry: LogEntry = {
        timestamp: +Date.now(),
        level: 'WARN',
        category: 'TaarWebRTC',
        message,
        data: args.length > 1 ? args.slice(1) : undefined
      };
      this.addLogEntry(logEntry);
      this.originalConsole.warn(...args);
    };

    console.error = (...args: any[]) => {
      const message = args.map(String).join(' ');
      const logEntry: LogEntry = {
        timestamp: +Date.now(),
        level: 'ERROR',
        category: 'TaarWebRTC',
        message,
        data: args.length > 1 ? args.slice(1) : undefined
      };
      this.addLogEntry(logEntry);
      this.originalConsole.error(...args);
    };
  }

  private addLogEntry(entry: LogEntry) {
    // Filter by log level
    const levels = ['DEBUG', 'INFO', 'WARN', 'ERROR'];
    const currentLevelIndex = levels.indexOf(this.config.logLevel!);
    const entryLevelIndex = levels.indexOf(entry.level);

    if (entryLevelIndex >= currentLevelIndex) {
      this.logs.push(entry);      
      // Keep only the last maxLogEntries
      if (this.logs.length > this.config.maxLogEntries!) {
        this.logs = this.logs.slice(-this.config.maxLogEntries!);
      }

      // Send to backend if enabled
      if (this.config.enableBackend && this.config.backendUrl) {
        this.sendToBackend(entry);
      }

      // Add to batch if enabled
      if (this.config.enableBatchLogging) {
        this.addToBatch({
          message: entry.message,
          context: entry.context || {},
          timestamp: entry.timestamp,
          level: entry.level
        });
      }
    }
  }

  private async sendToBackend(entry: LogEntry) {
    try {
      await fetch(this.config.backendUrl!, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...entry,
          userAgent: this.config.userAgent
        }),
      });
    } catch (error) {
      // Don't log this error to avoid infinite loops
      this.originalConsole.error('Failed to send log to backend:', error);
    }
  }

  private startBatchTimer(): void {
    if (this.batchTimer) {
      clearInterval(this.batchTimer);
    }
    
    this.batchTimer = setInterval(() => {
      this.flushBatch();
    }, this.config.batchTimeout);
  }

  private stopBatchTimer(): void {
    if (this.batchTimer) {
      clearInterval(this.batchTimer);
      this.batchTimer = null;
    }
  }

  private async flushBatch(): Promise<void> {
    if (this.logBuffer.length === 0 || !this.config.enableBatchLogging) {
      return;
    }

    const logsToSend = [...this.logBuffer];
    this.logBuffer = [];

    try {
      await this.sendBatchToGateway(logsToSend);
    } catch (error) {
      // Re-add logs to buffer if sending failed
      this.logBuffer.unshift(...logsToSend);
      this.originalConsole.error('[TaarWebRTC] Failed to send batch logs:', error);
    }
  }

  private async sendBatchToGateway(logs: BatchLogEntry[]): Promise<void> {
    if (!this.config.logGatewayUrl || !this.config.agentCredentials) {
      throw new Error('Batch logging not properly configured');
    }

    const payload = {
      logs: logs,
      timestamp: Date.now(),
      batchSize: logs.length,
      userAgent: this.config.userAgent
    };

    const response = await fetch(this.config.logGatewayUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.config.agentCredentials}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Failed to send logs: ${response.status} ${response.statusText}`);
    }
  }

  private addToBatch(entry: BatchLogEntry): void {
    if (!this.config.enableBatchLogging) {
      return;
    }

    this.logBuffer.push(entry);

    // Flush if buffer is full
    if (this.logBuffer.length >= (this.config.batchSize || 50)) {
      this.flushBatch();
    }
  }

  // Public API methods
  getUserAgent(): string {
    return this.config.userAgent || 'Unknown';
  }

  setUserAgent(userAgent: string): void {
    this.config.userAgent = userAgent;
  }

  setDebugMode(enabled: boolean): void {
    this.debugMode = enabled;
  }

  configureBatchLogging(config: Partial<LoggingConfig>): void {
    this.config = { ...this.config, ...config };
    
    if (this.config.enableBatchLogging && this.config.logGatewayUrl && this.config.agentCredentials) {
      this.startBatchTimer();
    } else {
      this.stopBatchTimer();
    }
  }

  log(message: string, context: LogContext = {}): void {
    const logEntry: LogEntry = {
      timestamp: context.timestamp || Date.now(),
      level: 'INFO',
      category: 'TaarWebRTC',
      message,
      context: {
        ...context,
        userAgent: context.userAgent || this.config.userAgent
      }
    };

    this.addLogEntry(logEntry);

    if (this.debugMode) {
      this.originalConsole.log("[TaarWebRTC]", { message, ...context });
    }
  }

  error(message: string, context: LogContext = {}): void {
    const logEntry: LogEntry = {
      timestamp: context.timestamp || Date.now(),
      level: 'ERROR',
      category: 'TaarWebRTC',
      message,
      context: {
        ...context,
        userAgent: context.userAgent || this.config.userAgent
      }
    };

    this.addLogEntry(logEntry);
    this.originalConsole.error("[TaarWebRTC]", { message, ...context });
  }

  warn(message: string, context: LogContext = {}): void {
    const logEntry: LogEntry = {
      timestamp: context.timestamp || Date.now(),
      level: 'WARN',
      category: 'TaarWebRTC',
      message,
      context: {
        ...context,
        userAgent: context.userAgent || this.config.userAgent
      }
    };

    this.addLogEntry(logEntry);
    this.originalConsole.warn("[TaarWebRTC]", { message, ...context });
  }

  debug(message: string, context: LogContext = {}): void {
    const logEntry: LogEntry = {
      timestamp: context.timestamp || Date.now(),
      level: 'DEBUG',
      category: 'TaarWebRTC',
      message,
      context: {
        ...context,
        userAgent: context.userAgent || this.config.userAgent
      }
    };

    this.addLogEntry(logEntry);

    if (this.debugMode) {
      this.originalConsole.log("[TaarWebRTC]", { message, ...context });
    }
  }

  // Log retrieval methods
  getLogs(): LogEntry[] {
    return [...this.logs];
  }

  getLogsByLevel(level: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR'): LogEntry[] {
    return this.logs.filter(log => log.level === level);
  }

  getLogsByCategory(category: string): LogEntry[] {
    return this.logs.filter(log => log.category === category);
  }

  getTimerLogs(): LogEntry[] {
    return this.logs.filter(log => log.category === 'JsSIP-Timer');
  }

  getTransactionLogs(): LogEntry[] {
    return this.logs.filter(log => log.message.includes('transaction'));
  }

  clearLogs(): void {
    this.logs = [];
  }

  async sendAllLogsToBackend(): Promise<void> {
    if (!this.config.enableBackend || !this.config.backendUrl) {
      throw new Error('Backend logging not configured');
    }

    try {
      await fetch(this.config.backendUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          logs: this.logs,
          timestamp: +Date.now(),
          userAgent: this.config.userAgent
        }),
      });
    } catch (error) {
      throw new Error(`Failed to send logs to backend: ${error}`);
    }
  }

  updateConfig(newConfig: Partial<LoggingConfig>): void {
    this.config = { ...this.config, ...newConfig };
  }

  // Force flush all pending logs
  async flushAllLogs(): Promise<void> {
    await this.flushBatch();
  }
}

// Global logger instance
let loggerInstance: UnifiedLogger | null = null;

export function initializeLogger(config?: LoggingConfig): UnifiedLogger {
  if (!loggerInstance) {
    loggerInstance = UnifiedLogger.getInstance(config);
  }
  return loggerInstance;
}

export function getLogger(): UnifiedLogger | null {
  return loggerInstance;
}

export function getLogs(): LogEntry[] {
  return loggerInstance?.getLogs() || [];
}

export function sendLogsToBackend(): Promise<void> {
  if (!loggerInstance) {
    throw new Error('Logger not initialized');
  }
  return loggerInstance.sendAllLogsToBackend();
}

export function getTimerLogs(): LogEntry[] {
  return loggerInstance?.getTimerLogs() || [];
}

export function getTransactionLogs(): LogEntry[] {
  return loggerInstance?.getTransactionLogs() || [];
}

export function getUserAgent(): string {
  return loggerInstance?.getUserAgent() || 'Unknown';
}

export function setUserAgent(userAgent: string): void {
  loggerInstance?.setUserAgent(userAgent);
}

export function detectUserAgent(): string {
  if (typeof navigator !== 'undefined') {
    return navigator.userAgent;
  }
  return 'Unknown';
}

export function isMobile(): boolean {
  const userAgent = detectUserAgent();
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
}

export function isDesktop(): boolean {
  return !isMobile();
}

export function getBrowserInfo(): { browser: string; version: string; os: string } {
  const userAgent = detectUserAgent();
  
  // Browser detection
  let browser = 'Unknown';
  let version = 'Unknown';
  
  if (userAgent.includes('Chrome')) {
    browser = 'Chrome';
    const match = userAgent.match(/Chrome\/(\d+)/);
    version = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Firefox')) {
    browser = 'Firefox';
    const match = userAgent.match(/Firefox\/(\d+)/);
    version = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    browser = 'Safari';
    const match = userAgent.match(/Version\/(\d+)/);
    version = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Edge')) {
    browser = 'Edge';
    const match = userAgent.match(/Edge\/(\d+)/);
    version = match ? match[1] : 'Unknown';
  }
  
  // OS detection
  let os = 'Unknown';
  if (userAgent.includes('Windows')) {
    os = 'Windows';
  } else if (userAgent.includes('Mac OS X')) {
    os = 'macOS';
  } else if (userAgent.includes('Linux')) {
    os = 'Linux';
  } else if (userAgent.includes('Android')) {
    os = 'Android';
  } else if (userAgent.includes('iOS')) {
    os = 'iOS';
  }
  
  return { browser, version, os };
}

// Initialize with default configuration
const defaultConfig: LoggingConfig = {
  enableConsole: true,
  enableBackend: false,
  logLevel: 'DEBUG',
  maxLogEntries: 1000,
  enableBatchLogging: false
};

initializeLogger(defaultConfig); 
